import { render, staticRenderFns } from "./Top5.vue?vue&type=template&id=18cd332e&scoped=true"
import script from "./Top5.vue?vue&type=script&lang=js"
export * from "./Top5.vue?vue&type=script&lang=js"
import style0 from "./Top5.vue?vue&type=style&index=0&id=18cd332e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18cd332e",
  null
  
)

export default component.exports